import React from "react";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import SingleWizardField from "./SingleWizardField";
import { Metadata } from "src/app/Task/Subtask/Subtask";
import { ProjectSetupType } from "../types";

interface WizardFieldsSectionProps {
  fields: Metadata[];
  currentSetup: ProjectSetupType;
}

export default function WizardFieldsSection({
  fields,
  currentSetup,
}: WizardFieldsSectionProps) {
  const isTemplate = currentSetup === ProjectSetupType.Template;
  const hasFields = fields.length > 0;

  if (!isTemplate || !hasFields) return null;

  return (
    <div
      className="create-new-project-pane__field"
      data-qa="predefined-project-fields"
    >
      <h4 className="text-h4-regular">
        <IDHFormattedMessage id="ws_details" defaultMessage="Details" />
      </h4>
      <div className="create-new-project-pane__wizard-fields">
        {fields.map((field) => (
          <SingleWizardField field={field} key={field.uuid} />
        ))}
      </div>
    </div>
  );
}
